import React from "react";
import CMSRender from "aldoo-ra/CMS/cms-render";
import BlogCategories from "./categories";
import Input from "aldoo-ra/Input";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import Button from "aldoo-ra/Button";
import Typography from "aldoo-ra/Typography";

const SearchAndCategories = ({
  searchQuery,
  setSearchQuery,
  searchCategory,
  setSearchCategory,
  getStatusMessage,
  clearSearch,
  handleSearchChange,
}) => {
  return (
    <div className="w-full flex flex-col items-center mx-auto lg:mx-0">
      {/* Categories and Search */}
      <div className="w-full flex flex-col lg:flex-row items-center lg:justify-between gap-4 lg:gap-8">
        {/* Render all categories */}
        {/* Temporarily hidden for website v 1.0 -----------*/}
        {/* <div className="hidden md:block">
          <CMSRender
            contentType="BlogCategory"
            render={(data, id) => (
              <BlogCategories
                key={id}
                categories={data}
                onItemClick={(category) => {
                  setSearchCategory(category);
                }}
              />
            )}
          />
        </div> */}

        {/* Search Input */}
        <div className="relative w-full max-w-[450px] md:max-w-[315px] lg:max-w-[367px] xl:max-w-[438px] md:ml-auto">
          <Input
            variant="mobilingo_standard"
            placeholder="Search for a blog post"
            className="h-[50px] xl:h-[60px] w-full rounded-full bg-gray_100 border-gray_200 shadow-none"
            icon={<MagnifyingGlassIcon className="w-[30px] h-[30px] text-gray_900"/>}
            onChange={handleSearchChange}
            value={searchQuery}
            showClearButton={true}
            onClear={clearSearch}
            clearButtonClassName="w-8 xl:w-[34px] h-8 xl:h-[34px] flex items-center justify-center bg-gray_200 text-gray_700 hover:text-text rounded-full clear-button-large md:mr-1 xl:mr-2"
          />
        </div>
      </div>

      {/* Search Status */}
      <div className="flex flex-row justify-center items-center gap-[20px] mt-4 md:ml-auto">
        <Typography
          variant="body1"
          className="my-0"
        >
          {getStatusMessage()}
        </Typography>
      </div>
    </div>
  );
};

export default SearchAndCategories;